import Tag from '../views/tags/Index.vue';
import { checkauth } from '../Helper';

// inserimento e modifica sono pagine: tornando indietro la lista riparte dal suo URL
const TagCreate = () => import('../views/tags/Create.vue');
const TagEdit = () => import('../views/tags/Edit.vue');

function auth(to, from, next) {
	checkauth().then(response => {
		if (response) {
			next();
		} else {
			next('/login');
		}
	});
}

export default [
	{
		path: '/tags',
		name: 'tags',
		component: Tag,
		beforeEnter: auth,
	},
	{
		path: '/tags/new',
		name: 'tag-new',
		component: TagCreate,
		beforeEnter: auth,
	},
	// :id e' l'_id del tag (24 caratteri esadecimali): "new" non puo' mai finire qui
	{
		path: '/tags/:id([0-9a-fA-F]{24})',
		name: 'tag-edit',
		component: TagEdit,
		beforeEnter: auth,
	},
];
